import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Form, Row, Col } from 'antd';
import styled from 'styled-components';
// import { Wrapper } from 'pages/life/forget/styledComponents';
import { ReactComponent as TravelIcon } from 'assets/images/Travel neutral.svg';
import PolicyAndMemberIdModal from '../forget/PolicyAndMemberIdModal';
import { revalidateAntdFormLanguageChanged } from '../../../i18n';
import { StyledTitle } from 'components/StyledTitle';
// import _get from 'lodash/get';
import ProgressSteps from './components/ProgressSteps';
const RegistrationCard = styled(Card)`
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
`;

const ResponsiveContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;

  @media (max-width: 768px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const Wrapper = styled.div`
  display: grid;
  row-gap: 12px;
  width: 600px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

function RegistrationSelectPage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = React.useState(false);

  const [form] = Form.useForm();

  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [form, i18n.language]);

  const closeModel = () => {
    setIsModalVisible(false);
  };
  return (
    <ResponsiveContainer>
      {/* <IconTitle title={t('launch.registerBtn')} level={2} icon={regIcon} /> */}
      <RegistrationCard
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '0',
          fontFamily: 'Roboto400',
        }}
      >
        <ProgressSteps activeStepIndex={0} />

        <Wrapper style={{ backgroundColor: 'white', borderRadius: 0, border: 0, paddingTop: 0 }}>
          {/* <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            > */}
          <Row justify="center" gutter={[16, { xs: 8, sm: 16, md: 24 }]}>
            <Col
              xs={24}
              md={24}
              style={{ display: 'flex', justifyContent: 'center', paddingTop: '24px', textAlign: 'center' }}
            >
              <StyledTitle level={4} fontWeight="400">
                {t('life.register.selectText')}
              </StyledTitle>
            </Col>
            {/* <Divider /> */}
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <TravelIcon title="Travel Icon" width="176" height="176" />
            </Col>
            <Col
              xs={24}
              md={24}
              style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
            >
              <Button
                block
                type="default"
                size="large"
                onClick={() => navigate('/register/LifeRegistrationLanding')}
                style={{
                  color: '#C21B17',
                  width: '70%',
                  height: '56px',
                  fontSize: '20px',
                  fontWeight: 'Roboto500',
                  maxWidth: '100%',
                  borderColor: '#c21b17',
                  fontFamily: 'Roboto500',
                  marginBottom: '12px',
                }}
              >
                {t('registration.lifeInsurance')}
              </Button>

              <Button
                block
                type="default"
                size="large"
                onClick={() => navigate('/register/EbConnectPolicy')}
                style={{
                  color: '#C21B17',
                  width: '70%',
                  height: '56px',
                  fontSize: '20px',
                  fontWeight: 'Roboto500',
                  maxWidth: '100%',
                  borderColor: '#c21b17',
                  fontFamily: 'Roboto500',
                }}
              >
                {t('registration.employeeBenefits')}
              </Button>
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <StyledTitle color="#6f6072" fontSize="17px" margin="0 0 24px 0">
                {t('registration.explanation')}
              </StyledTitle>
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              {/* <Link
                style={{
                  fontWeight: 'normal',
                  marginLeft: 4,
                  marginRight: 4,
                  color: '#C21B17',
                  textDecoration: 'underline',
                }}
                to="/forgot/login"
                onClick={(e) => e.preventDefault()}
              >
                {t('forgetLoginId.help')}
              </Link> */}
            </Col>
          </Row>
          {/* </div> */}
        </Wrapper>
      </RegistrationCard>
      <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={closeModel} />
    </ResponsiveContainer>
  );
}

export default RegistrationSelectPage;
